import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../../api/api";
import { ICertificateOfInsurance } from "./certificateOfInsurance.types";

export const fetchCertificateOfInsuranceList = createAsyncThunk<
  {
    data: ICertificateOfInsurance[];
    totalRecords: number;
  },
  {
    type: string;
    pageNumber: number;
    rowPerPage: number;
    status?: string;
  }
>(
  "certificateOfInsurance/fetchCertificateOfInsuranceList",
  async ({ type, pageNumber, rowPerPage, status }, { rejectWithValue }) => {
    try {
      let url = `/policy/get-policy-add-liability-insurance-certificate?pageNo=${pageNumber}&itemPerPage=${rowPerPage}`;

      if (status && status !== "-1") {
        url += `&status=${status}`;
      }
      const res = await api.get(url);
      const data: ICertificateOfInsurance[] = res.data.data;
      const totalRecords = res.data.totalRecords;

      return {
        data: data || [],
        totalRecords: totalRecords || 0,
      };
    } catch (err: any) {
      return rejectWithValue(err);
    }
  },
);
